export enum EMarqueAppareilSurface {

    ACSperhi = 1,
    // AES,
    // OXOID,
    // ThermoFisher,
}